import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { EmptySiteKey } from '@portal-core/sites/constants/empty-site-key.constant';
import { AlertType } from '@portal-core/general/enums/alert-type.enum';

export const pageNotFoundGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  const siteKey = next.params.siteKey || EmptySiteKey;

  router.navigate(['/', siteKey, 'alert'], { queryParams: { type: AlertType.PageNotFound } });

  return false;
};
